export const Team24Promo = () => {
    return (
        <section id="team-24-promo">
            <h2>Atlassian Team &apos;24</h2>
            <hr />
        </section>
    );
};
